/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_list__aria_label__filter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Filter öffnen`
};

const en_poi_list__aria_label__filter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Open filters`
};

const es_poi_list__aria_label__filter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Filtros abiertos`
};

const fr_poi_list__aria_label__filter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Ouvrir les filtres`
};

const it_poi_list__aria_label__filter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Filtri aperti`
};

const nl_poi_list__aria_label__filter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Open filters`
};

const pt_poi_list__aria_label__filter_button = /** @type {(inputs: {}) => string} */ () => {
	return `Filtros abertos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_list__aria_label__filter_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_list__aria_label__filter_button", locale)
	if (locale === "de") return de_poi_list__aria_label__filter_button(inputs)
	if (locale === "en") return en_poi_list__aria_label__filter_button(inputs)
	if (locale === "es") return es_poi_list__aria_label__filter_button(inputs)
	if (locale === "fr") return fr_poi_list__aria_label__filter_button(inputs)
	if (locale === "it") return it_poi_list__aria_label__filter_button(inputs)
	if (locale === "nl") return nl_poi_list__aria_label__filter_button(inputs)
	return pt_poi_list__aria_label__filter_button(inputs)
};